<template>
  <div class="systemDoorDetail">
    <div class="systemDoorDetailBox">
      <el-row>
        <el-col :span="22">查看门店详情</el-col>
        <el-col :span="2">
          <el-button
            type="info"
            round
            icon="el-icon-back"
            size="small"
            @click="goBack()"
          >
            返 回
          </el-button>
        </el-col>
      </el-row>
      <div class="detailBox">
        <div class="line">
          <label>门店名称</label>
          <span>{{detailData.name}}</span>
        </div>
        <div class="line">
          <label>门店编号</label>
          <span>{{detailData.doorNo}}</span>
        </div>
        <div class="line">
          <label>区域</label>
          <span>{{detailData.regionName}}</span>
        </div>
        <div class="line">
          <label>城市</label>
          <span>{{detailData.cityName}}</span>
        </div>
        <div class="line">
          <label>客户</label>
          <span>{{detailData.resellerName}}</span>
        </div>
        <div class="line">
          <label>等级</label>
          <span>{{detailData.doorClass}}</span>
        </div>
        <!-- <div class="line">
          <label>Master V</label>
          <span>
            <el-radio v-model="masterV" :label="1">是</el-radio>
            <el-radio v-model="masterV" :label="0">否</el-radio>
          </span>
        </div> -->
      </div>
      <footer>
        <el-button type="success" @click="goBack()">
          关 闭
        </el-button>
        <el-button type="success" @click="save()">
          保 存
        </el-button>
      </footer>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";

export default {
  name: "SystmenDoorDetail",
  data() {
    return {
      id: this.$route.query.id,
      masterV: 0,
      detailData: {
        name: '门店名称门店名称门店名称门店名称',
        address: '门店地址',
        doorNo: '门店编号',
        regionName: 'Great Bay',
        cityName: '上海',
        resellerName: '客户',
        doorClass: '等级'
      }
    }
  },
  mounted() {
    if (this.id) {
      this.getData()
    }
  },
  methods: {
    async getData() {
      let url = "door/"+this.id;
      let res = await axios.post(vmsReqUrl+url);
      res = res.data;
      if (res.code === 200) {
        this.detailData = res.data;
        this.masterV = this.detailData.masterV
      }
    },
    goBack() {
      this.$router.push({ path: '/vms/doorManage' });
    },
    async save() {
      let res = await axios.post(vmsReqUrl+"/door/edit", {
        masterV: this.masterV,
        id: this.id
      });
      res = res.data;
      if (res.code === 200) {
        this.$message.success(res.message)
      }
    }
  }
};
</script>
<style lang="sass" scoped>
.systemDoorDetail
  min-width: 800px
  .systemDoorDetailBox
    padding: 20px
    .detailBox
      width: 50%
      margin-left: 25%
      margin-top: 20px
      margin-bottom: 20px
      .line
        height: 60px
        line-height: 60px
        font-size: 14px
        color: #707070
        border-bottom: 1px solid #ccc
        display: flex
        label
          color: #a8a8a8
          width: 25%
    footer
      padding-top: 30px
      text-align: center

</style>



// WEBPACK FOOTER //
// src/vms/pages/views/systemDoorDetail.vue